import React from "react";
import PropTypes from "prop-types";
import { View, Text } from "@react-pdf/renderer";
import { formatNumber, formatPercentage } from "../../../helpers/formatter";
import styles from "./description.styles";

export default function Description({ stats }) {
  const indicator =
    stats.qualityIndicator && stats.qualityIndicator.toLowerCase();

  return (
    <View style={styles.card}>
      <View style={styles["card-row"]}>
        <View style={styles["card-col-label"]}>
          <Text style={styles["card-title"]}>Name</Text>
        </View>
        <View style={styles["right-column"]}>
          <Text style={styles["card-row-title"]}>{stats.name}</Text>
        </View>
      </View>
      <View style={styles["card-row"]}>
        <View style={[styles["card-col-label"], styles["padding-top"]]}>
          <Text style={styles["card-title"]}>Audience description</Text>
        </View>
        <View style={styles["right-column"]}>
          <Text style={styles["card-row-description"]}>
            {stats.description}
          </Text>
        </View>
      </View>
      <View style={styles["card-row"]}>
        <View style={styles["card-col-label"]}>
          <Text style={styles["card-title"]}>Data input</Text>
        </View>
        <View style={styles["right-column"]}>
          <Text style={styles["card-row-title"]}>{stats.audienceType}</Text>
        </View>
      </View>
      <View style={styles["card-row"]}>
        <View style={[styles["card-col-label"], styles["padding-top"]]}>
          <Text style={styles["card-title"]}>Reach</Text>
        </View>
        <View style={styles["right-column"]}>
          <Text>
            <Text style={styles["card-row-value"]}>
              {stats.populationLl && formatNumber(stats.populationLl)}{" "}
            </Text>
            People
          </Text>
          <Text>
            <Text style={styles["card-row-value"]}>
              {stats.reachLl && formatPercentage(stats.reachLl)}{" "}
            </Text>
            Population
          </Text>
        </View>
      </View>
      <View style={styles["card-row"]}>
        <View style={styles["card-col-label"]}>
          <Text style={styles["card-title"]}>Precision</Text>
        </View>
        <View style={styles["right-column"]}>
          <View style={styles.afinity}>
            {/* <View style={[styles.status, styles[indicator]]} /> */}
            <Text style={[styles.value, styles[`${indicator}-text`]]}>
              {stats.precisionLl && stats.precisionLl.toFixed(1)}
              <Text style={{ color: "black" }}> Affinity</Text>
            </Text>
          </View>
        </View>
      </View>
    </View>
  );
}

Description.propTypes = {
  stats: PropTypes.shape({
    audienceVariables: PropTypes.arrayOf(
      PropTypes.arrayOf(PropTypes.shape({}))
    ),
    name: PropTypes.string,
    description: PropTypes.string,
    audienceType: PropTypes.string,
    precisionLl: PropTypes.number,
    populationLl: PropTypes.number,
    reachLl: PropTypes.number,
    qualityIndicator: PropTypes.string
  }).isRequired
};
